import React, { useState } from 'react';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import 'moment-timezone';
import { uuid } from 'uuidv4';
import Metric from "../../telemetry"; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import constants from "./constants"; // Components

import SelectField from "../../components/SelectField";
import Button from "../../components/Button";
import "./style.css";

const AvailabilityForm = () => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    expertTimezone,
    availabilityStore_imp,
    schedule
  } = state;
  const [type, setType] = useState('client');
  const [fromDate, setFromDate] = useState(moment());
  const [toDate, setToDate] = useState(moment().add(7, 'days'));
  const [fromTime, setFromTime] = useState('09:00');
  const [toTime, setToTime] = useState('18:00');
  const [timezone, setTimezone] = useState(availabilityStore_imp.officeTimezone.name);
  const [focus, setFocus] = useState(null);
  const [days, setDays] = useState(['MON', 'TUE', 'WED', 'THU', 'FRI']);
  const weekdays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

  const formData = () => {
    const newDays = days.map(x => x.toLocaleLowerCase());
    const startHour = parseInt(fromTime.split(':')[0]);
    const endHour = parseInt(toTime.split(':')[0]);
    const startMinutes = parseInt(fromTime.split(':')[1]);
    const endMinutes = parseInt(toTime.split(':')[1]);

    const buildDays = () => {
      const Nu_days = Math.abs(fromDate.diff(toDate, 'days'));
      const dayArr = [];
      const isExpert = type !== 'client';

      for (let i = 0; i <= Nu_days; i++) {
        const dayOfWeek = moment(fromDate).add(i, 'days').format('ddd').toLocaleLowerCase();

        if (newDays.includes(dayOfWeek)) {
          dayArr.push(moment(fromDate).add(i, 'days'));
        }
      }

      const result = dayArr.map(x => {
        const date = x.format('YYYY-MM-DD');
        const startTime = `${startHour}:${startMinutes}`;
        const endTime = `${endHour}:${endMinutes}`;
        const obj = {
          type: isExpert ? 'expert' : 'client',
          id: uuid(),
          time: {
            start: parseInt(moment(date + ' ' + startTime).format('x')),
            end: parseInt(moment(date + ' ' + endTime).format('x'))
          },
          raw: {
            group: []
          }
        };
        return obj;
      });
      return result;
    };

    return buildDays();
  };

  const changeTime = key => e => {
    if (key === 'fromTime') {
      setFromTime(e.target.value);
    } else {
      setToTime(e.target.value);
    }
  };

  const changeDate = ({
    startDate,
    endDate
  }) => {
    setFromDate(startDate);
    setToDate(endDate);
  };

  const onSetFocus = focusedInput => {
    setFocus(focusedInput);
  };

  const renderDays = () => {
    return weekdays.map(day => /*#__PURE__*/React.createElement("label", {
      className: "days",
      id: "special_input_styling",
      key: day
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      name: "day",
      value: day,
      checked: days.includes(day),
      onChange: e => {
        const spliced = days.slice();
        spliced.splice(spliced.indexOf(day), 1);
        setDays(e.target.checked ? [...days, day] : spliced);
      }
    }), day));
  };

  const isEqual = (el1, el2) => {
    return JSON.stringify(el1.sort()) === JSON.stringify(el2.sort());
  };

  const switchTz = () => {
    if (type === 'client') {
      setTimezone(expertTimezone.name);
      setType('expert');
      Metric.wizardToggleType('expert');
    } else {
      setTimezone(availabilityStore_imp.officeTimezone.name);
      setType('client');
      Metric.wizardToggleType('client');
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "availability-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-availability"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-availability-title"
  }, window && window.outerWidth < 768 ? /*#__PURE__*/React.createElement("div", {
    className: "button-group"
  }, /*#__PURE__*/React.createElement(Button, {
    className: `button-part${type === 'client' ? ' active' : ''}`,
    label: 'Client',
    onClick: switchTz
  }), /*#__PURE__*/React.createElement(Button, {
    className: `button-part${type !== 'client' ? ' active' : ''}`,
    label: 'Expert',
    onClick: switchTz
  })) : /*#__PURE__*/React.createElement("label", {
    className: "form-switch"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: 10
    }
  }, "Client"), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "cOrE",
    onClick: switchTz
  }), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "Expert"))), /*#__PURE__*/React.createElement("div", {
    className: "form-availability-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(SelectField, {
    name: 'timezone',
    value: timezone,
    label: 'Time Zone',
    options: availabilityStore_imp.staticData.timezones.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    }).map(x => /*#__PURE__*/React.createElement("option", {
      key: x.id,
      value: x.name
    }, x.name, ' ', moment().utc().tz(x.name).format('Z'))),
    onChange: e => setTimezone(e.target.value),
    bulk: true,
    availabilityStore: availabilityStore_imp
  }), /*#__PURE__*/React.createElement(Button, {
    className: 'form-button',
    label: 'Current Timezone',
    onClick: () => {
      setTimezone(moment.tz.guess(true));
      Metric.wizardTimezone();
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-block"
  }, /*#__PURE__*/React.createElement("h1", null, "Time Range"), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(SelectField, {
    name: 'from',
    value: fromTime,
    label: 'From',
    options: constants.time.map(t => ({
      name: t,
      value: t
    })),
    onChange: changeTime('fromTime'),
    bulk: true,
    availabilityStore: availabilityStore_imp
  }), /*#__PURE__*/React.createElement(SelectField, {
    name: 'to',
    value: toTime,
    label: 'To',
    options: constants.time.map(t => ({
      name: t,
      value: t
    })),
    onChange: changeTime('toTime'),
    availabilityStore: availabilityStore_imp
  }), /*#__PURE__*/React.createElement(Button, {
    className: 'form-button',
    label: 'Business Hours',
    onClick: () => {
      setFromTime('09:00');
      setToTime('18:00');
      Metric.wizardTimeRange();
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-block"
  }, /*#__PURE__*/React.createElement("h1", null, "Duration"), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "column"
  }, /*#__PURE__*/React.createElement(DateRangePicker, {
    numberOfMonths: window.matchMedia('(max-width: 400px)').matches ? 1 : 2,
    orientation: window.matchMedia('(max-width: 400px)').matches ? 'horizontal' : 'vertical',
    small: true,
    startDatePlaceholderText: "From",
    endDatePlaceholderText: "To",
    showDefaultInputIcon: true,
    inputIconPosition: "after",
    displayFormat: 'DD.MM.YYYY',
    startDate: fromDate,
    startDateId: "from",
    endDate: toDate,
    endDateId: "to",
    onDatesChange: changeDate,
    focusedInput: focus,
    onFocusChange: focusedInput => onSetFocus(focusedInput),
    noBorder: true
  })), /*#__PURE__*/React.createElement("div", {
    className: `${window && window.outerWidth < 768 ? 'button-group' : ''}`,
    style: window && window.outerWidth < 768 ? {
      marginTop: 10,
      width: '100%'
    } : {}
  }, /*#__PURE__*/React.createElement(Button, {
    className: `${window && window.outerWidth < 768 ? 'button-part form-button' : 'form-button'}`,
    label: 'Today',
    onClick: () => {
      setFromDate(moment());
      setToDate(moment().add(1, 'days'));
      Metric.wizardDuration('today');
    },
    style: {
      width: window && window.outerWidth < 768 ? 'auto' : 90,
      flex: 1,
      padding: 0,
      margin: 0
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: `${window && window.outerWidth < 768 ? 'button-part form-button' : 'form-button'}`,
    label: 'Single Day',
    onClick: () => {
      setToDate(moment(fromDate).add(1, 'days'));
      Metric.wizardDuration('1Day');
    },
    style: {
      width: window && window.outerWidth < 768 ? 'auto' : 90,
      flex: 1,
      padding: 0,
      margin: 0,
      marginLeft: 5
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: `${window && window.outerWidth < 768 ? 'button-part form-button' : 'form-button'}`,
    label: '1 Week',
    onClick: () => {
      setToDate(moment(fromDate).add(7, 'days'));
      Metric.wizardDuration('1week');
    },
    style: {
      width: window && window.outerWidth < 768 ? 'auto' : 90,
      flex: 1,
      padding: 0,
      margin: 0,
      marginLeft: 5
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: `${window && window.outerWidth < 768 ? 'button-part form-button' : 'form-button'}`,
    label: '2 Weeks',
    onClick: () => {
      setToDate(moment(fromDate).add(14, 'days'));
      Metric.wizardDuration('2weeks');
    },
    style: {
      width: window && window.outerWidth < 768 ? 'auto' : 90,
      flex: 1,
      padding: 0,
      margin: 0,
      marginLeft: 5
    }
  })))), toDate && fromDate && toDate.diff(fromDate, 'days') > 1 && /*#__PURE__*/React.createElement("div", {
    className: "form-block"
  }, /*#__PURE__*/React.createElement("h1", null, "Day Range"), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "button-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "radio"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "range",
    value: "weekdays",
    checked: isEqual(days, ['MON', 'TUE', 'WED', 'THU', 'FRI']),
    onChange: () => {
      setDays(['MON', 'TUE', 'WED', 'THU', 'FRI']);
      Metric.wizardDayRange('weekdays');
    }
  }), "Weekdays")), /*#__PURE__*/React.createElement("div", {
    className: "radio"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "range",
    value: "weekends",
    checked: isEqual(days, ['SAT', 'SUN']),
    onChange: () => {
      setDays(['SAT', 'SUN']);
      Metric.wizardDayRange('weekends');
    }
  }), "Weekends")), /*#__PURE__*/React.createElement("div", {
    className: "check-group",
    style: {
      marginTop: 10
    }
  }, renderDays())))), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement(Button, {
    className: 'action-button',
    label: 'Add',
    onClick: () => {
      const result = schedule.availabilities.concat(formData());
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            availabilities: result
          }
        }
      });
      dispatch({
        type: 'UPDATE',
        payload: {
          currentPath: 'calendarview'
        }
      });
      Metric.wizardAddAvailabilities(type);
    },
    style: {
      width: 110,
      height: 40,
      padding: 0,
      margin: 20,
      marginLeft: 0,
      background: '#3A86BF',
      fontSize: 14,
      fontWeight: '700',
      fontFamily: 'Roboto'
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: 'action-button cancelButton',
    label: 'Cancel',
    onClick: () => {
      dispatch({
        type: 'UPDATE',
        payload: {
          currentPath: 'calendarview',
          ExpertOffsetSet: false,
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          }
        }
      });
    },
    style: {
      width: 110,
      height: 40,
      padding: 0,
      margin: 20,
      marginLeft: -10,
      background: '#FFF',
      color: '#3A86BF',
      fontSize: 14,
      fontWeight: '700',
      fontFamily: 'Roboto',
      border: '1px solid #3A86BF'
    }
  })))));
};

export default AvailabilityForm;